export const alternativeSiteListSelector = state => state.alternativeSiteReducer.alternativeSiteList;

export const loadingAlternativeSitesSelector = state => state.alternativeSiteReducer.loadingAlternativeSites;
